import { getRequestPhase } from '../../../../../api'
import { EMPTY_LIST } from '../../../../../constants/common'
import {
  getPipelinePhase,
  getPipelinePhaseActivities,
} from '../../../../Pipeline'

export function getPhaseWithActivities({ activities, phase }) {
  return {
    ...phase,
    activities: activities || EMPTY_LIST,
  }
}

export function fetchPhaseWithActivities({ outboundUuid, phaseId }) {
  return Promise.all([
    getPipelinePhase({ outboundUuid, phaseId }),
    getPipelinePhaseActivities({ outboundUuid, phaseId }),
  ]).then(([{ data: phase }, { data: activities }]) =>
    getPhaseWithActivities({ activities, phase })
  )
}

export function fetchPhasesWithActivities({
  outboundUuid,
  phases = EMPTY_LIST,
}) {
  if (phases.length === 0) {
    return Promise.resolve(EMPTY_LIST)
  }

  return Promise.all(
    phases.map(phase =>
      getPipelinePhaseActivities({ outboundUuid, phaseId: phase.id }).then(
        ({ data: activities }) => getPhaseWithActivities({ activities, phase })
      )
    )
  )
}

export function loadAllPhasesWithActivities({ outboundUuid, requestId }) {
  return getRequestPhase({ id: requestId, outboundUuid }).then(
    ({ data: pipelinePhases }) =>
      fetchPhasesWithActivities({
        outboundUuid,
        phases: pipelinePhases ?? EMPTY_LIST,
      })
  )
}

export function reloadPhasesByIds({ outboundUuid, phaseIds }) {
  return Promise.all(
    phaseIds.map(phaseId => fetchPhaseWithActivities({ outboundUuid, phaseId }))
  )
}

export function getPhaseIdsToReload({ phaseId, previousPhaseId }) {
  return [...new Set([phaseId, previousPhaseId].filter(Boolean))]
}

export function mergePhaseIntoPhases(phases, phaseWithActivities) {
  if (phases.length === 0) {
    return [phaseWithActivities]
  }

  const phaseIndex = phases.findIndex(
    phase => phase.id === phaseWithActivities.id
  )

  if (phaseIndex === -1) {
    return phases
  }

  const nextPhases = [...phases]

  nextPhases[phaseIndex] = phaseWithActivities

  return nextPhases
}

export function mergePhasesIntoPhases(phases, phasesWithActivities) {
  return phasesWithActivities.reduce(
    (acc, phaseWithActivities) =>
      mergePhaseIntoPhases(acc, phaseWithActivities),
    phases
  )
}
